// extracted by mini-css-extract-plugin
export default {"globalFonts":"fonts_globalFonts__wQoCI","back":"fonts_back__wBcQT","front":"fonts_front__ZU4Ma"};